import { render, staticRenderFns } from "./NotConfirmed.vue?vue&type=template&id=1a259bbc&scoped=true&"
import script from "./NotConfirmed.vue?vue&type=script&lang=js&"
export * from "./NotConfirmed.vue?vue&type=script&lang=js&"
import style0 from "./NotConfirmed.vue?vue&type=style&index=0&id=1a259bbc&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a259bbc",
  null
  
)

export default component.exports